import axios from 'axios';
import React from 'react'
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom'
import Loading from '../Loading/Loading';
import Error from '../Error/Error';

export default function ProductDetails() {
    const getProductDetails = (id) => {
        return axios.get(`https://ecommerce.routemisr.com/api/v1/products/${id}`)

    }
    const { productId } = useParams();
    const { isLoading, isError, data } = useQuery('productDetails', () => getProductDetails((productId)));

    return <>
        {isLoading && <Loading />}
        {isError && <Error />}
        {data && <div className='row align-items-center'>
            <div className="col-md-4">
                <img className='w-100' src={data?.data.data.imageCover} alt={data?.data.data.title} />
            </div>
            <div className="col-md-8">
                <h2 className='h5'> {data?.data.data.title}</h2>
                <p>{data?.data.data.description}</p>
                <h6 className='text-main'>{data?.data.data.name}</h6>
                <h6 className='text-main'>{data?.data.data.price}</h6>
                <div className="d-flex justify-content-between">
                    <span>Rating Quantity : {data?.data.data.ratingsQuantity}</span>
                    <span > <i className='fas fa-star rating-color'></i >  {data?.data.data.ratingsAverage}</span>
                </div>
                <button className='btn bg-main text-white w-100 mt-2'>Add to cart</button>
            </div>
        </div>}
    </>
}
